import { Component, type ReactNode } from "react";

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
}

export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="flex min-h-screen items-center justify-center bg-white px-6 text-slate-900">
          <div className="w-full max-w-lg rounded-2xl border border-slate-200 p-6 shadow-sm">
            <h1 className="text-xl font-semibold">No se pudo mostrar el panel</h1>
            <p className="mt-2 text-sm text-slate-600">
              Se ha producido un error inesperado al representar esta pantalla.
              La sesion y los datos del panel no se han eliminado.
            </p>
            <button
              type="button"
              className="mt-5 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white"
              onClick={() => window.location.reload()}
            >
              Recargar panel
            </button>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}
